"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  num: "01",
  title: "Sicurezza",
  desc: "La tua tranquillità è la nostra priorità. Verifichiamo rigorosamente ogni imbarcazione e l'equipaggio per garantirti standard di sicurezza impeccabili in mare."
}, {
  num: "02",
  title: "Conoscenza Locale",
  desc: "Profonda esperienza delle acque di Ibiza e Formentera. Ti guidiamo verso le calette più esclusive e i percorsi meno battuti, lontano dalla folla."
}, {
  num: "03",
  title: "Flotta Esclusiva",
  desc: "Accesso privilegiato a una selezione rigorosa di yacht di lusso, dai modelli Entry ai superyacht Elite, garantendo sempre la massima qualità."
}, {
  num: "04",
  title: "Supporto 24/7",
  desc: "Assistenza dedicata in ogni fase del tuo viaggio. Il nostro team è sempre a disposizione per risolvere qualsiasi imprevisto o soddisfare ogni tua richiesta."
}];
function FeatureBlock({
  feature,
  index
}: {
  feature: (typeof features)[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    rootMargin: "0px 0px -10% 0px"
  });
  return <div ref={ref} data-index={index} className={`flex flex-col transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
    transitionDelay: `${index * 150}ms`
  }}>
      <span className="text-7xl md:text-8xl lg:text-9xl font-default font-bold text-secondary mb-6 md:mb-10 tracking-tighter">
        {feature.num}
      </span>
      <h3 className="text-2xl md:text-3xl font-default font-bold text-foreground mb-4 md:mb-6">
        {feature.title}
      </h3>
      <p className="text-lg md:text-xl text-muted-foreground font-default leading-relaxed max-w-md">
        {feature.desc}
      </p>
    </div>;
}
export default function WhyChooseAnExpertBroker() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="perché-scegliere-un-broker-esperto" className="bg-background py-32 md:py-48 lg:py-64 overflow-hidden">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div ref={headerRef} className={`mb-24 md:mb-40 max-w-3xl transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold text-foreground tracking-tight leading-tight">
            Perché Scegliere un Broker Esperto
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 lg:gap-x-32 gap-y-24 md:gap-y-40">
          {features.map((feature, i) => <FeatureBlock key={i} feature={feature} index={i} />)}
        </div>
      </div>
    </section>;
}